import { FrontPage } from 'src/app/reppl/frontpage';
import { RepplPageLayout } from 'src/app/reppl/layout';
import { repplStaticProps } from 'src/app/reppl/ssg';
import { staticPaths } from 'src/lib/ssg';
import { useModal } from 'src/hooks/use-modal';
import { UserContext, UserContextType } from 'src/contexts/UserContext';
// import loginAuth from 'src/heplers/auth-page';
// import Loading from 'src/components/common/loading/loading';
import SignInModal from 'src/app/article/sign-in-modal';
import { useContext, useEffect } from 'react';

function RepplPage({ rid }) {
  const { isLogin } = useContext(UserContext) as UserContextType;
  // const isAuth = loginAuth(isLogin, '/signin');
  // if (!isAuth || !isLogin) {
  //   return <Loading />;
  // }
  const signinModal = useModal();

  useEffect(() => {
    if (!isLogin) {
      signinModal.onSelect(true);
    } else {
      signinModal.modal.onClose();
    }
  }, [isLogin]);
  return (
    <>
      <FrontPage rid={rid} />
      {signinModal.selected && (
        <SignInModal
          isOpen={signinModal.modal.isOpen}
          onOpen={signinModal.modal.onOpen}
          onClose={() => {}}
          onToggle={signinModal.modal.onToggle}
          getButtonProps={signinModal.modal.getButtonProps}
          getDisclosureProps={signinModal.modal.getDisclosureProps}
          isControlled={signinModal.modal.isControlled}
          handleClose={signinModal.modal.onClose}
          title="This content is password protected. To view it please enter your password below:"
        />
      )}
    </>
  );
}

RepplPage.Layout = RepplPageLayout;

export const getStaticProps = repplStaticProps;
export const getStaticPaths = staticPaths;
export default RepplPage;
